
import { Component, Vue, Prop } from 'vue-property-decorator';
// eslint-disable-next-line no-unused-vars
import { iUploadeImagesList } from '@/interface/imageUpload';
@Component({})
export default class extends Vue {
  @Prop({ default: '.png,.jpg' }) type!: string;
  @Prop({ default: '1' }) size!: string;
  @Prop({ default: false }) invaildH!: boolean;
  @Prop({ default: 211 }) maxH!: number;
  @Prop({ default: 520 }) maxW!: number;
  @Prop({ default: 148 }) customWith!: number;

  @Prop({ default: [] }) images!: iUploadeImagesList[];
  @Prop({ default: false }) isMultiple!: boolean;
  @Prop({ default: false }) isVideo!: boolean;
  @Prop({ default: 0 }) gameType!: number;
  @Prop({ default: false }) isValidate!: boolean;
  @Prop({ default: false }) isMaxWValidata!: boolean;
  @Prop({ default: false }) isMaxHValidata!: boolean;
  dialogVisible: boolean = false;
  // images = [];
  beforeImgUpLoad(file: any) {
    return new Promise<void>((resolve, reject) => {
      let reader = new FileReader();

      reader.onload = (e: any) => {
        let data = e.target.result;
        //加载图片获取图片真实宽度和高度
        let image = new Image();
        image.onload = async () => {
          let width = image.width;
          let height = image.height;
          file.image_height = height;
          file.image_width = width;
          //console.log(file);
          let isPass = await this.uploadRules(file);
          if (!isPass) {
            reject();
          } else {
            resolve();
          }
        };
        image.src = data;
      };
      reader.readAsDataURL(file);
    }).then(
      () => {
        return file;
      },
      () => {
        return Promise.reject();
      }
    );
  }

  uploadRules(file: any) {
    return new Promise(resolve => {
      const isLt2M = file.size / 1024 / 1024 < Number(this.size);
      const isJPG = file.name.substring(file.name.lastIndexOf('.'), file.name.length);
      let istype = this.type.includes(`${isJPG}`);
      if (!istype) {
        this.$message.error(`图片格式仅支持 ${this.type} 格式，请重新上传`);
        resolve(false);
      }
      if (this.isValidate) {
        if ((this.invaildH ? false : file.image_height !== Number(this.maxH)) || file.image_width !== Number(this.maxW)) {
          this.$message.error('图片尺寸不符合要求，请重新上传!');
          resolve(false);
        }
        if (!isLt2M) {
          this.$message.error(`图片大小不能超过${this.size}MB`);
          resolve(false);
        }
      }
      // console.log('当前图片规格： ', file.image_width, file.image_height);
      if (this.isMaxWValidata) {
        if (file.image_width > Number(this.maxW)) {
          this.$message.error('图片宽度必须小于' + this.maxW + 'px，请重新上传!');
          return resolve(false);
        }
      }
      if (this.isMaxHValidata) {
        if (file.image_height > Number(this.maxH)) {
          this.$message.error('图片高度必须小于' + this.maxH + 'px，请重新上传!');
          return resolve(false);
        }
      }
      resolve(true);
    });
  }
  uploadSuccess(file: any) {
    let files = file.status;
    let item: iUploadeImagesList = {
      url: files.preview_url,
      type: this.gameType,
    };
    if (this.isMultiple) {
      this.images.push(item);
    } else {
      this.images.splice(0, 1);
      this.images.push(item);
    }
    // console.log('--upload-', this.images);
  }
  beforeRemove(file: any) {
    if (file && file.status === 'success') {
      // return this.$confirm(`确定删除吗?`);
      return this.$confirm('确定删除吗?', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        title: '提示',
      });
    }
  }
  /* 移除 */
  removeImage(file: any) {
    if (file && file.status === 'success') {
      const indexNum: number = this.images.findIndex(item => {
        return item.url == file.url;
      });
      if (indexNum > -1) {
        this.images.splice(indexNum, 1);
      }
    }
  }

  mounted() {
    // console.log('dee');
    //console.log(this.images);
    // console.log(this.fillText1);
  }
}
